import styled from 'astroturf/react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
import { BareButton } from '@calendly/ui/components/bare-button'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { PopupDropdownMenu } from '@calendly/ui/components/menu'
import _MenuButtonContainer from "styles-MenuButtonContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/publisher_toolbar/dropdown/styles.js?styleId=MenuButtonContainer";
import _BurgerItem from "styles-BurgerItem.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/publisher_toolbar/dropdown/styles.js?styleId=BurgerItem";
import _Burger from "styles-Burger.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/publisher_toolbar/dropdown/styles.js?styleId=Burger";
import _Cross from "styles-Cross.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/publisher_toolbar/dropdown/styles.js?styleId=Cross";
import _Menu from "styles-Menu.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/publisher_toolbar/dropdown/styles.js?styleId=Menu";


export const MenuButtonContainer = /*#__PURE__*/styled(BareButton, null, {
  displayName: "MenuButtonContainer",
  styles: _MenuButtonContainer
})

const BurgerItem = /*#__PURE__*/styled('div', null, {
  displayName: "BurgerItem",
  styles: _BurgerItem
})

export const Burger = /*#__PURE__*/styled('div', null, {
  displayName: "Burger",
  styles: _Burger,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp'),
    children: <>
      <BurgerItem />
      <BurgerItem />
      <BurgerItem />
    </>
  })
})

export const Cross = /*#__PURE__*/styled('div', null, {
  displayName: "Cross",
  styles: _Cross,
  attrs: props => ({
    ...props,
    children: '×'
  })
})

export const Menu = /*#__PURE__*/styled(PopupDropdownMenu, null, {
  displayName: "Menu",
  styles: _Menu
})
